import { z } from 'zod'

export const CustomEventSchema = z.object({
  event_id: z.number(),
  title: z.string(),
  description: z.string().nullable(),
  meta_type: z.number(),
  ts_updated: z.string(),
})

export type CustomEvent = z.infer<typeof CustomEventSchema>
